export default __webpack_public_path__ + "static/media/trash-2-red.0da96d12.svg";